var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 8.52273L1.14583 15.7955C0.895833 16.0682 0.4375 16.0682 0.1875 15.7955C-0.0625 15.5227 -0.0625001 15.0227 0.1875 14.75L6.39583 7.97727L0.187499 1.25C-0.0625007 0.977273 -0.0625007 0.477273 0.187499 0.204545C0.437499 -0.068182 0.895833 -0.068182 1.14583 0.204545L7.8125 7.47727C8.0625 7.75 8.0625 8.25 7.8125 8.52273Z",
    fill: "#B9AE9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.a8d38e031fd7ecd74eb4ab0224f16064.svg";
export { ForwardRef as ReactComponent };